import { AUTH_ENDPOINT_BASE_URL, AUTH_ENDPOINT_BASE_URL_PARAMS } from './config'

export const environment = {
  production: true,
  authenticated: false,
  hmr: false,
  authUrl: `${AUTH_ENDPOINT_BASE_URL}/go_665ac2b65dabc617e3aa5db914b2129fG3SSLUW1bDE?
  ${AUTH_ENDPOINT_BASE_URL_PARAMS}`,
}
